import { createErrorReportingAsyncThunk, withRetries } from "../../helpers";
import axios, { getData } from "../../../axios";
import * as tPromise from "io-ts-promise";
import { createSlice } from "@reduxjs/toolkit";
import {
  DefaultCopyOption,
  DefaultDispatcherViewValue,
  userSettingsT,
} from "dora-contracts";
import { assign } from "lodash";
import { notifyL } from "../../notifications";

const prefix = "data/user-settings";

type UserSettings = {
  defaultDispatcherView: DefaultDispatcherViewValue;
  removeDropoffByDefault: boolean;
  defaultCopyOption: DefaultCopyOption;
  defaultCreateCopyOption: DefaultCopyOption;
};

const initialState: UserSettings = {
  defaultDispatcherView: "ROUTES_VIEW",
  removeDropoffByDefault: false,
  defaultCopyOption: "COPY_WITH_INVOICE_LINES_RESET_QTY",
  defaultCreateCopyOption: "COPY_WITH_INVOICE_LINES",
};

export const loadUserSettings = createErrorReportingAsyncThunk(
  `${prefix}/loadUserSettings`,
  async () => {
    return withRetries(() =>
      axios
        .get(`/api/user-settings`)
        .then(getData)
        .then(tPromise.decode(userSettingsT))
    );
  }
);

export const saveUserSettingsDispatcherView = createErrorReportingAsyncThunk(
  `${prefix}/saveDispatcherView`,
  async (defaultDispatcherView: DefaultDispatcherViewValue, thunkAPI) => {
    return axios
      .put(`/api/user-settings/default-dispatcher-view`, {
        value: defaultDispatcherView,
      })
      .then(() => {
        thunkAPI.dispatch(
          notifyL({
            type: "success",
            namespace: "notifications",
            key: "settingsSaved",
          })
        );
      });
  }
);

export const saveUserSettingsRemoveDropoffByDefault =
  createErrorReportingAsyncThunk(
    `${prefix}/saveRemoveDropoffByDefault`,
    async (removeDropoffByDefault: boolean, thunkAPI) => {
      return axios
        .put(`/api/user-settings/remove-dropoff-by-default`, {
          value: removeDropoffByDefault,
        })
        .then(() => {
          thunkAPI.dispatch(
            notifyL({
              type: "success",
              namespace: "notifications",
              key: "settingsSaved",
            })
          );
        });
    }
  );

export const saveUserSettingsDefaultCopyOption = createErrorReportingAsyncThunk(
  `${prefix}/saveDefaultCopyOption`,
  async (defaultCopyOption: DefaultCopyOption, thunkAPI) => {
    return axios
      .put(`/api/user-settings/default-copy-option`, {
        value: defaultCopyOption,
      })
      .then(() => {
        thunkAPI.dispatch(
          notifyL({
            type: "success",
            namespace: "notifications",
            key: "settingsSaved",
          })
        );
      });
  }
);

export const saveUserSettingsDefaultCreateCopyOption =
  createErrorReportingAsyncThunk(
    `${prefix}/saveDefaultCreateCopyOption`,
    async (defaultCreateCopyOption: DefaultCopyOption, thunkAPI) => {
      return axios
        .put(`/api/user-settings/default-create-copy-option`, {
          value: defaultCreateCopyOption,
        })
        .then(() => {
          thunkAPI.dispatch(
            notifyL({
              type: "success",
              namespace: "notifications",
              key: "settingsSaved",
            })
          );
        });
    }
  );

const slice = createSlice({
  name: prefix,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadUserSettings.fulfilled, (state, action) => {
      assign(state, action.payload);
    });
  },
});

export default slice.reducer;
